import React, { Component } from 'react'
// import PropTypes from 'prop-types'
import { Link, withRouter } from 'react-router-dom'
import { compose, withApollo } from 'react-apollo'
import {
  Form,
  // Modal,
  // Button,
  // Input,
  // Tabs,
  // message,
  Menu,
  Dropdown,
  Icon
} from 'antd'
import { FormattedMessage } from 'react-intl'
import { inject, observer } from 'mobx-react'
import _get from 'lodash/get'
// import queryString from 'query-string'
// import currentUserQuery from '../../App/graphql/queries/currentUser.gql'
import withUser from '../../App/hocs/withUser'
import './style.css'
// import _get from 'lodash/get'
// console.log('auth', auth)
import {
  // registerUser,
  // loginUser,
  logoutUser
  // getAuthUri
} from '../../auth'

import { HeaderWrapper } from '~/styles'

const locales = {
  en: 'EN',
  th: 'TH',
  zh: 'CN'
}

class Header extends Component {
  // static contextType = {
  //   client: PropTypes.object
  // }
  constructor (props) {
    super(props)
    this.state = {
      toggle: false,
      visible: false,
      loginLoading: false,
      signupLoading: false,
      checkScroll: 0
    }
    this.clickMenu = this.clickMenu.bind(this)
    this.showLoginModal = this.showLoginModal.bind(this)
    this.cancelLogin = this.cancelLogin.bind(this)
  }
  // TODO: move auth logic outside Header

  handleLogout = () => {
    // console.log('Logout')
    logoutUser().then(() => {
      this.props.client.resetStore()
      this.props.history.push('/')
    })
  }

  showLoginModal () {
    this.setState({
      visible: true
    })
  }

  componentDidMount () {
    if (window) {
      window.addEventListener('scroll', this.handleScroll)
    }
  }

  componentWillUnmount () {
    if (window) {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }

  handleScroll = e => {
    if (window && document) {
      // let display = e.srcElement.body.scrollTop
      // let header = document.querySelector('.ant-layout-header')

      // if (display <= 0) {
      //   header.classList.remove('onScoll')
      // } else if (display > this.state.checkScroll) {
      //   header.classList.add('onScoll')
      // } else {
      //   header.classList.remove('onScoll')
      // }
      // this.setState({
      //   checkScroll: display
      // })
    }
    // if (display !== 0) {
    //   header.classList.add('onScoll')

    // } else {
    //   header.classList.remove('onScoll')
    // }
  }
  clickMenu () {
    // console.log(this.state.toggle)
    if (window && document) {
      let header = document.querySelector('.ant-layout-header')
      let dropdown = document.querySelector('.dropDown')
      if (!this.state.toggle) {
        header.classList.add('clickMenu')
        dropdown.classList.remove('hideDropDown')
        this.setState({ toggle: true })
      } else {
        header.classList.remove('clickMenu')
        dropdown.classList.add('hideDropDown')
        this.setState({ toggle: false })
      }
    }
  }
  clickDropDownMenuItem () {
    window.scrollTo(0, 0)
    if (window && document) {
      let header = document.querySelector('.ant-layout-header')
      let dropdown = document.querySelector('.dropDown')
      if (!this.state.toggle) {
        header.classList.add('clickMenu')
        dropdown.classList.remove('hideDropDown')
        this.setState({ toggle: true })
      } else {
        header.classList.remove('clickMenu')
        dropdown.classList.add('hideDropDown')
        this.setState({ toggle: false })
      }
    }
  }
  cancelLogin () {
    this.setState({
      visible: false
    })
  }

  handleLanguageChange (locale) {
    const { i18n } = this.props
    // console.log({ i18n })
    i18n.setLocale(locale)
  }

  render () {
    const { currentUser, i18n } = this.props
    const locale = i18n.locale
    const menu = (
      <Menu>
        <Menu.Item key="menu1">
          <Link to="/profile">Profile</Link>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item key="menu4">
          <div onClick={this.handleLogout}>
            <FormattedMessage id="app.logout"/>
          </div>
        </Menu.Item>
      </Menu>
    )
    // console.log('currentUser', currentUser)
    // const $authFields =
    return (
      <HeaderWrapper>
        <div className="header">
          <div className="headerBg">
            <Link to="/" onClick={() => window.scrollTo(0, 0)}>
              <img src="/logo.png" className="logo" alt="" />
            </Link>
            <div className="menu_icon">
              <i className="material-icons" onClick={this.clickMenu}>dehaze</i>
            </div>
            <div className="headerMenu">
              <div className="menuItem">
                {/*
                <a href="https://thai.run" className="menuItem">
                <FormattedMessage id="app.photoSearch" defaultMessag="ค้นหาภาพถ่าย" />
                </a>
                */}
                <Link to="/" key="races" onClick={() => window.scrollTo(0, 0)} className="menuItem baseBtn">
                  <FormattedMessage id="app.races"/>
                </Link>
                {currentUser && [
                  <Link to="/dashboard" key="dashboard" className="menuItem baseBtn">
                    <FormattedMessage id="app.myRegistrations" defaultMessag="My Registrations" />
                  </Link>
                ]}
                <span>
                  {currentUser
                    ? <div className="menuItem">
                      <Dropdown overlay={menu} trigger={['click']}>
                        <a className="ant-dropdown-link login_btn baseBtn logout">
                          {currentUser.profile.firstName} {_get(currentUser, 'profile.lastName.0', '')}. <Icon type="down" />
                        </a>
                      </Dropdown>
                    </div>
                    : <div className="menuItem">
                      <div
                        className="login_btn baseBtn menuItem"
                        onClick={this.props.onAuthClick}
                      >
                        <FormattedMessage id="app.loginOrRegister"/>
                      </div>
                    </div>}
                </span>
                <span className="localeSwitcher menuItem">
                  {Object.entries(locales).map(([key, label], i) => (
                    <span key={key}>
                      {i !== 0 && <span className="localeSeparator" />}
                      <span
                        onClick={() => this.handleLanguageChange(key)}
                        className={key === locale ? 'active locale' : 'locale'}
                      >
                        {label}
                      </span>
                    </span>
                  ))}
                </span>
              </div>
            </div>
            <div className="dropDown hideDropDown">
              {/*
              <div className="menuList">
              <a href="https://thai.run"><FormattedMessage id="app.photoSearch" defaultMessag="ค้นหาภาพถ่าย" /></a>
              </div>
            */}
              <div className="menuList">
                <Link to="/" key="races" onClick={() => this.clickDropDownMenuItem()} className="menuItem">
                  <FormattedMessage id="app.races"/>
                </Link>
              </div>
              {currentUser &&
                <div className="menuList">
                  <Link to="/dashboard" key="dashboard" onClick={() => this.clickDropDownMenuItem()} className="menuItem">
                    <FormattedMessage id="app.myRegistrations" defaultMessag="My Registrations" />
                  </Link>
                </div>}
              <div className="menuList">
                <span className="localeSwitcher menuItem" >
                  {Object.entries(locales).map(([key, label], i) => (
                    <span key={key}>
                      {i !== 0 && <span className="localeSeparator" />}
                      <span
                        onClick={() => this.handleLanguageChange(key)}
                        className={key === locale ? 'active locale' : 'locale'}
                      >
                        {label}
                      </span>
                    </span>
                  ))}
                </span>
              </div>
              {currentUser
                ? <div
                  className="loginButtonDropDown menuList"
                  onClick={this.handleLogout}
                >
                  <div className="menuItem">
                    <FormattedMessage id="app.logout"/>
                  </div>
                </div>
                : <div
                  className="loginButtonDropDown menuList"
                  onClick={this.props.onAuthClick}
                >
                  <div className="menuItem">
                    <FormattedMessage id="app.loginOrRegister"/>
                  </div>
                </div>
              }
              {/* <div className="menuList">
                <Link to="/pricing" key="pricing" onClick={() => this.clickDropDownMenuItem()} className="menuItem">
                  <FormattedMessage id="app.pricing"/>
                </Link>
              </div> */}
            </div>
          </div>
        </div>
      </HeaderWrapper>
    )
  }
}

export default compose(
  inject('i18n'),
  Form.create(),
  withUser(),
  // graphql(currentUser),
  withRouter,
  withApollo,
  observer
)(Header)



// WEBPACK FOOTER //
// ./src/common/Header/Header.js